import React, { useEffect, useState } from "react";
import GroupOrder from "../../assets/GroupOrder.png";
import calender from "../../assets/calender.png";
import profile from "../../assets/profile.png";
import address from "../../assets/orders/address.png";
import desc from "../../assets/orders/desc.png";
import upload from "../../assets/orders/upload.png";
import statusIcon from "../../assets/orders/status.png";
import stepsPrice from "../../assets/orders/stepsPrice.png";
import { Button, Carousel, Checkbox, Modal, Radio, Space } from "antd";
import Recommended from "./Recommended";
import credit from "../../assets/checkout/credit.png";
import cash from "../../assets/checkout/cash.png";
import { updateOrderFunction } from "../../redux/orderUpdateSlice";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const Pricing = ({
  idOrder,
  agentName,
  agentLastName,
  image,
  date,
  time,
  addresss,
  description,
  statuss,
  stat,
  images,
  clear_price,
  AgentImage,
  agent_description,
  updated_atDate,
  updated_at,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenPrice, setIsModalOpenPrice] = useState(false);
  const [isModalOpenAcceptPrice, setIsModalOpenAcceptPrice] = useState(false);

  const { t, i18n } = useTranslation();
  const { language } = i18n;

  const [isModalView, setIsModalView] = useState(false);

  const showModalView = () => {
    setIsModalView(true);
  };
  const handleOkView = () => {
    setIsModalView(false);
  };
  const handleCancelView = () => {
    setIsModalView(false);
  };

  const showModalPricing = () => {
    setIsModalOpenPrice(true);
  };

  const handleOkPrice = () => {
    setIsModalOpenPrice(false);
  };

  const handleCancelPrice = () => {
    setIsModalOpenPrice(false);
  };

  const showModalAcceptPrice = () => {
    setIsModalOpenAcceptPrice(true);
  };

  const handleOkAcceptPrice = () => {
    setIsModalOpenAcceptPrice(false);
  };

  const handleCancelAcceptPrice = () => {
    setIsModalOpenAcceptPrice(false);
  };

  const dispatch = useDispatch();

  const { updateOrder, statusUpdate } = useSelector(
    (state) => state.updateOrder
  );

  // useEffect(() => {
  //   if (statusUpdate === "idle") {
  //     dispatch(updateOrderFunction("acceptperview", idOrder));
  //   }
  // }, [dispatch, statusUpdate]);

  // const handleAcceptPrice = () => {
  //   if (showModalAcceptPrice) {
  //     dispatch(updateOrderFunction("acceptperview", idOrder));
  //   }
  // };

  const onChange = (e) => {
    console.log(`checked = ${e.target.checked}`);
  };

  const [current, setCurrent] = useState(0);

  const next = () => {
    setCurrent(current + 1);
  };

  const prev = () => {
    setCurrent(current - 1);
  };

  const onFinish = (values) => {
    console.log("Form Data:", values);
  };

  const [phone, setPhone] = useState("");
  const [selected, setSelected] = useState("evaluation");

  const handleChange = (value) => {
    console.log(`selected ${value}`);
  };

  const [value, setValue] = useState(1);
  const onChangeShipping = (e) => {
    console.log("radio checked", e.target.value);
    setValue(e.target.value);
  };

  const [pay, setPay] = useState("credit");
  // const [method, setMethod] = useState(true);
  const onChangePay = (e) => {
    console.log("radio checked", e.target.pay);
    setPay(e.target.value);
  };

  const handleMethod = () => {
    // if(pay == "credit"){
    //   setMethod(true)
    // }else{
    //   setMethod(false)
    // }
  };

  return (
    <div>
      <img
        src={image}
        className="w-[120px] bg-[#FCFBFA] p-3 rounded-2xl mx-auto my-5"
      />
      <div className="text-center">
        <p className="text-[#737E91] font-semibold text-xl">
        {t("Order number")} 
          <span className="text-[#283D63] font-semibold">#{idOrder}</span>
        </p>
        <p className="text-[#A6ADB9] mt-2">
        {t("Order created on")} {updated_atDate} <br /> {updated_at}
        </p>
      </div>

      <img src={stepsPrice} className="w-[300px] mx-auto my-5" />

      <div className="bg-[#FCFBFA] rounded-2xl my-5 px-7 py-4">
        <div className="flex items-center">
          {AgentImage == null ? (
            <img src={profile} className={`w-[48px] ${language == "en" ? "mr-3" : "ml-3"}`} />
          ) : (
            <img
              src={AgentImage}
              className={`w-[48px] ${language == "en" ? "mr-3" : "ml-3"} rounded-full`}
              onError={(e) => (e.target.src = profile)}
            />
          )}

          <p className="text-[#525D71] font-medium text-lg">
            {agentName} {agentLastName}  {t("is checking your service request cost. Sorry to keep you waiting")}
          </p>
        </div>
      </div>

      <div className="flex mx-auto">
        <button
          onClick={showModalPricing}
          className={`bg-[#FE9B71] ${
            clear_price == 0 || stat == "scaned_qr" ? "bg-[#fe9b714f]" : ""
          } text-white rounded-xl py-3 px-10 mx-auto text-center text-white font-medium`}
          disabled={clear_price == 0 || stat == "scaned_qr"}
        >
          {t("View Pricing")}
        </button>
        <Modal
          title="Pricing Details"
          className="orderModal orderModalPricing"
          open={isModalOpenPrice}
          onOk={handleOkPrice}
          onCancel={handleCancelPrice}
          footer={null}
        >
          <div>
            <h3 className="text-[#283D63] text-xl">{t("Service Explanation")}</h3>
            <div className="bg-[#F9FBFC] rounded-2xl text-[#A3B9DD] px-5 py-3 my-4 text-lg h-[130px] overflow-auto">
              <p>
                {agent_description == null
                  ? "No description added"
                  : agent_description}
              </p>
            </div>
          </div>
          <div className="flex justify-between items-center bg-[#FCFBFA] rounded-2xl px-7 py-4 lg:mx-40 mt-5">
            <div>
              <p className="text-[#525D71] font-medium text-lg">
                {agentName} {agentLastName} {t("is on the way to you")}
              </p>
              <p className="text-[#A4ADBC] text-lg">{t("Price")}</p>
              <p className="text-[#FE9B71] text-lg">{clear_price} {t("SR")}</p>
            </div>
            <div>
              {AgentImage == null || !AgentImage ? (
                <img
                  src={profile}
                  className={`w-[58px] ${language == "en" ? "mr-3" : "ml-3"} rounded-full`}
                  onError={(e) => (e.target.src = profile)}
                />
              ) : (
                <img src={AgentImage} className={`w-[58px] ${language == "en" ? "mr-3" : "ml-3"} rounded-full`} />
              )}
            </div>
          </div>

          <div className="flex justify-center my-7">
            <button
              onClick={() => {
                // dispatch(
                //   updateOrderFunction({
                //     status: "acceptperview",
                //     order_id: idOrder,
                //   })
                // );
                dispatch(
                  updateOrderFunction({
                    status: "acceptperview",
                    order_id: idOrder,
                    includeDevice: false,
                  })
                );

                setIsModalOpenPrice(false);
              }}
              className="bg-[#FE9B71] text-white rounded-full py-2 px-10 max-lg:px-4 font-medium text-lg"
            >
               {t("Accept Price")}
            </button>

            <button
              onClick={async (e) => {
                e.preventDefault();

                const payload = {
                  order_id: idOrder,
                  includeDevice: true,
                  status: "cancelled",
                };

                try {
                  const result = await dispatch(
                    updateOrderFunction(payload)
                  ).unwrap();
                  console.log(t("Payment response"), result);

                  if (result.payment_url) {
                    window.open(result.payment_url, "_blank");
                  } else {
                    console.error(t("Payment URL not found in the response."));
                  }
                } catch (error) {
                  console.error(t("Payment failed"), error);
                }
              }}
              className={`bg-white text-[#FE9B71] border-2 border-[#FE9B71] rounded-full py-2 px-10 max-lg:px-4 font-medium text-lg ${language == "en" ? "ml-5" : "mr-5"}`}
            >
              {t("Decline Price")}
            </button>
          </div>
        </Modal>
      </div>

      <div className="px-5 mt-4">
        <div className="grid grid-cols-2 gap-4 max-xl:grid-cols-1 items-center">
          <div className="flex items-center mt-3 ">
            <img src={calender} className={`w-[28px] ${language == "en" ? "mr-2" : "ml-2"}`} />
            <p className="text-[#283D63] font-medium">
              {date} | {time}
            </p>
          </div>
          <div className="flex items-center mt-3 ">
            <img src={address} className={`w-[28px] ${language == "en" ? "mr-2" : "ml-2"}`} />
            <p className="text-[#283D63] font-medium">{addresss}</p>
          </div>
        </div>

        <div className="flex items-start mt-5 ">
          <img src={desc} className={`w-[28px] ${language == "en" ? "mr-2" : "ml-2"}`} />
          <p className="text-[#283D63] font-medium">{description}</p>
        </div>

        <div className="grid grid-cols-2 gap-4 max-xl:grid-cols-1 items-center">
          <div className="flex items-center mt-5 ">
            <img
              src={upload}
              className={`w-[28px] ${language == "en" ? "mr-2" : "ml-2"}`}
            />
            {images?.length > 0 ? (
              <>
                <button
                  onClick={showModalView}
                  className="text-[#6682B6] underline font-medium"
                >
                  {t("View Uploaded Images")}
                </button>
                <Modal
                  title={t("Uploaded Images")}
                  className="orderModal orderModalPricing w_small_modal"
                  open={isModalView}
                  onOk={handleOkView}
                  onCancel={handleCancelView}
                  footer={null}
                >
                  <Carousel
                    arrows
                    infinite={false}
                    className="custome_carousel_images"
                  >
                    {images?.map((img, index) => (
                      <div key={index}>
                        <img
                          src={`https://service.samoolah.com/${img}`}
                          alt={`Uploaded image ${index + 1}`}
                          className="w-[120px] mx-auto my-5"
                        />
                      </div>
                    ))}
                  </Carousel>
                </Modal>
              </>
            ) : (
              <p className="text-[#283D63] font-medium">
                {t("No Uploaded Images")}
              </p>
            )}
          </div>
          <div className="flex items-center mt-3 ">
            <img src={statusIcon} className={`w-[28px] ${language == "en" ? "mr-2" : "ml-2"}`} />
            <p className="text-[#737E91] font-medium">{t("Status")}</p>
            <p className={`text-[#283D63] font-medium ${language == "en" ? "ml-2" : "mr-2"}`}>{statuss}</p>
          </div>
        </div>
      </div>

      {/* <Recommended /> */}
    </div>
  );
};

export default Pricing;
